import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import {makeStyles} from '@material-ui/core/styles';

import { getHexWithOpacity } from 'lib/util';

const useStyles = makeStyles(theme => ({
  root : {
    display: 'flex',
    columnGap: '12px',
    rowGap: '12px',
    flexWrap: 'wrap',
    marginTop: '12px',
    justifyContent: 'center',
  },
  columnDirection: {
    flexDirection: 'column',
    flexWrap: 'nowrap',
    alignItems: 'center',
    rowGap: '15px',
  },
  button: {
    height: '55px',
    borderRadius: '50px',
    border: '1px solid',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    padding: '20px 38px;',
    fontSize: '16px',
    fontWeight: '500',
    width: ({columnDirection}) => columnDirection && '300px',
    boxShadow: theme.shadow(15),
    borderColor: theme.palette.common.lightBorder,
    background: theme.palette.common.white,
    color: theme.palette.common.battleshipGrey,
    '&:hover' : {
      background: theme.palette.common.paleGrey
    },
    '&:active' : {
      background: theme.palette.grey[200]
    },
  },
  buttonSelected: {
    background: theme.palette.common.darkSlateBlue,
    borderColor: theme.palette.common.fauxIndigo,
    color: theme.palette.common.white,
    '&:hover' : {
      background: getHexWithOpacity(theme.palette.common.darkSlateBlue, 90),
    },
    '&:active' : {
      background: getHexWithOpacity(theme.palette.common.darkSlateBlue, 95),
    },
  },
}));

export const MultiChoiceSelection = (
  {
    data,
    selectedValues,
    onChange,
    isSingleChoice=false,
    handleSingleChoiceClick,
    columnDirection,
    className=''
  }) => {
  const classes = useStyles({columnDirection: columnDirection});

  const [selected, setSelected] = useState(selectedValues && new Set(selectedValues));

  useEffect(() => {
    if (!selected) return;
    onChange([...selected]);
  }, [selected]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleOnClick = item => {
    let newSet;

    setSelected(prevState => {
      newSet = new Set(prevState);

      if (prevState?.has(item)) {
        newSet.delete(item);
        return newSet;
      }

      if (isSingleChoice && newSet.size > 0)
        newSet = new Set();

      newSet.add(item);
      return newSet;
    });

    isSingleChoice && newSet.size && handleSingleChoiceClick();
  };

  return (
    <div className={classNames(classes.root, className, columnDirection && classes.columnDirection)}>
      {data.map((item, index) =>
        <div
          className={classNames(classes.button, selected?.has(item) && classes.buttonSelected)}
          key={`multi-select-button-${index}`}
          onClick={() => handleOnClick(item)}
        >
          {item}
        </div>
      )}
    </div>
  );
};

MultiChoiceSelection.propTypes = {
  data: PropTypes.array.isRequired,
  selectedValues: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func.isRequired,
  isSingleChoice: PropTypes.bool,
  handleSingleChoiceClick: PropTypes.func,
  className: PropTypes.string,
  columnDirection: PropTypes.bool,
};

export default MultiChoiceSelection;